import React from 'react';
function Header(){
    return(<>
        <div className="row">
            <h3><i className="fas fa-donate"></i>&nbsp;Donations</h3>
            <div className='pm-button col-sm-6'>
                <a href='https://www.payumoney.com/paybypayumoney/#/00A515A975E3D07561E8539F4BDA8235'>
                    <img alt="donate" src='https://www.payumoney.com/media/images/payby_payumoney/new_buttons/22.png' />
                </a>
                <a href="https://onboarding.payumoney.com/app/account?partner_name=Yash&partner_source=Affiliate+Links&partner_uuid=11ea-9690-41b260fc-9371-02aa98a2d2b0&source=Partner" target="blank"><img width="100px" height="100px" alt="payuImg" src="https://partner.payu.in/packs/_/assets/images/icons/certified-partner-ce70c676cc844c678e8a6e7e373e6c0d.png" />
                </a>
            </div> 
            <div style={{backgroundColor:'#3b7bbf',textAlign:'center',height:'45px',borderRadius:'5px'}} className='pm-button col-sm-4'><a style={{color:'#fff'}} href="https://paypal.me/yashdatir">Paypal</a></div>
        </div>

        </>
    )
}
export default Header;